<template>
  <div class="member-cell">
    <AppAvatar
      size="speck"
      :avatar="avatar"
    />
    <div class="member-label">
      <span class="ellipsis">{{ name }}</span>
      <span
        v-if="showTimeZone && timeZone"
        class="member-zone ellipsis z-text-gray-500"
      >
        ({{ timeZone.offset }}) {{ timeZone.display_name }}
      </span>
    </div>
  </div>
</template>

<script>
import AppAvatar from '~/components/AppAvatar.vue';

export default {
  name: 'InsightsUnusualActivityMemberCell',
  components: {
    AppAvatar,
  },
  props: {
    avatar: {
      type: [String, Object],
      required: false,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    timeZone: {
      type: Object,
      required: false,
      default: null,
    },
    showTimeZone: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped>
.member-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
}

.member-label {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
</style>
